import BigNumber from 'bignumber.js';

/**
 * positionSize = leverage * collateral;
 *
 * leverage = positionSize / collateral
 *
 * @returns
 */
export const getLeverage = ({
  collateralUsd,
  sizeUsd,
}: {
  sizeUsd: BigNumber;
  /**
   * after fee
   */
  collateralUsd: BigNumber;
}): BigNumber => {
  if (collateralUsd.isZero()) {
    return new BigNumber(0);
  }

  return sizeUsd.div(collateralUsd);
};
